import { styled } from "@mui/system";
import { ReactComponent as Icon } from "../../../assets/icons/add.svg";

export const StyledUploadContainer = styled("div")(({ theme }) => ({
  "& .fieldDescription": {
    display: "flex",
    fontSize: "0.875rem",
    fontWeight: "500",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    marginBottom: "8px",
    width: "fit-content"
  },
  "& .uploadInfoIcon": {
    fill: "#909093",
    width: "16px",
    height: "16px",
    marginLeft: "8px"
  },
  "& .uplaodContainer": {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    border: "1px dashed #86868B",
    borderRadius: "10px",
    flexDirection: "column",
    justifyContent: "space-between",
    cursor: "pointer",
    gap: "24px",
    outline: "none",
    "&.disabledUpload": {
      opacity: 0.5,
      pointerEvents: "none"
    },
    [theme.breakpoints.up("sm")]: {
      padding: "24px",
      flexDirection: "row",
      minWidth: "unset",
      maxWidth: "unset"
    }
  },
  "& .main": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    width: "100%",
    minWidth: 0,
    [theme.breakpoints.between("sm", "md")]: {
      width: "calc(100% - 105px)",
      flexDirection: "row",
      gap: "20px"
    },
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      gap: "20px"
    }
  },
  "& .row": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "unset"
    }
  },
  "& .success": {
    color: "#157947",
    fontWeight: 500
  },
  "& .error": {
    color: "#8D0C10",
    wordBreak: "break-word"
  },
  "& .contentContainer": {
    width: "100%",
    textAlign: "center",
    marginLeft: "0px",
    flexDirection: "column",
    [theme.breakpoints.between("sm", "md")]: {
      flexDirection: "row",
      width: "calc(100% - 54px)",
      textAlign: "left",
      marginTop: "0px"
    },
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      width: "calc(100% - 54px)",
      textAlign: "left",
      marginTop: "0px"
    }
  },
  "& .content": {
    fontSize: "1rem",
    fontWeight: 500,
    width: "100%",
    color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
    "& p": {
      margin: "0px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },
  "& .subcontent": {
    fontSize: "12px",
    fontWeight: 400,
    color: "#757575",
    "&.error": {
      color: "#8D0C10",
      wordBreak: "break-word"
    }
  },
  "& .actionButton": {
    "&.MuiButton-root": {
      minWidth: "105px",
      height: "40px",
      border: "1px solid #1F1F1F",
      borderRadius: "21px",
      textTransform: "capitalize",
      fontSize: "1rem",
      fontWeight: 500,
      padding: 20,
      letterSpacing: "normal",
      "@media (max-width: 372px)": {
        marginLeft: 0
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.875rem"
      },
      "&.MuiButton-containedPrimary": {
        color: "#fff",
        backgroundColor: "#000000"
      },
      "&.MuiButton-outlinedPrimary": {
        color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
        "&:hover": {
          border: "1px solid #1F1F1F",
          background: "rgba(0, 0, 0, 0.04)",
          color: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
        }
      }
    }
  },
  "& .isUploadingStatus": {
    marginRight: "unset",
    marginLeft: "8px",
    [theme.breakpoints.up("sm")]: {
      marginRight: "8px"
    }
  },
  "& .contentWrapper": {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "7px",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      alignItems: "flex-start"
    },
    "input[type='file']": {
      display: "none"
    }
  }
}));

export const AddIcon = styled(Icon)(() => ({
  width: "16px",
  height: "16px",
  marginRight: "8px"
}));

/**
 * Container for document items with border and shadow
 * @type {import('@mui/system').StyledComponent}
 */
export const Container = styled("div")(({ theme }) => ({
  borderRadius: "16px",
  padding: "12px 12px 16px",
  backgroundColor: "var(--Color-Background-Primary-Light, #FFF)",
  marginBottom: "16px",
  [theme.breakpoints.up("sm")]: {
    padding: "32px"
  }
}));

/**
 * Styled header for document sections
 * @type {import('@mui/system').StyledComponent}
 */
export const Header = styled("header")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px"
}));

/**
 * Container for company document items
 * @type {import('@mui/system').StyledComponent}
 */
export const CompanyDocuments = styled("div")(({ theme }) => ({
  display: "flex",
  paddingTop: "10px",
  paddingBottom: "30px",
  paddingLeft: "24px",
  paddingRight: "10px",
  boxShadow: "0 5px 21px 0 rgba(0, 0, 0, 0.03)",
  borderTop: "solid 1px #e8e8e8",
  backgroundColor: "#ffffff"
}));

/**
 * Wrapper for company icon
 * @type {import('@mui/system').StyledComponent}
 */
export const CompanyIconWrap = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "40px",
  height: "40px",
  border: "solid 1px #e9e9ed",
  borderRadius: "50%",
  backgroundColor: "#ffffff",
  "&>img": {
    height: "unset",
    width: "20px"
  }
}));

/**
 * Wrapper for file icon
 * @type {import('@mui/system').StyledComponent}
 */
export const FileIconWrap = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#ffffff"
}));

/**
 * Box for content display
 * @type {import('@mui/system').StyledComponent}
 */
export const ContentBox = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: "1",
  paddingLeft: "16px",
  paddingRight: "16px"
}));

/**
 * Label styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Label = styled("p")(({ theme }) => ({
  margin: "0",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "24px",
  textTransform: "capitalize",
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)",
  [theme.breakpoints.up("sm")]: {
    fontSize: "20px",
    lineHeight: "28px"
  }
}));

/**
 * Label styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Placeholder = styled("p")(({ theme }) => ({
  width: "32px",
  height: "32px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50px",
  background: "var(--Color-Palette-Red-50, #FDE7E8)",
  fontSize: "16px",
  lineHeight: "140%",
  fontWeight: "400",
  color: "var(--Color-Text-Secondary-On-Light, #757575)",
  margin: 0,
  [theme.breakpoints.up("sm")]: {
    width: "54px",
    height: "54px",
    fontSize: "24px"
  }
}));

/**
 * Box for controls
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ControlsBox = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "12px 32px",
  cursor: "pointer",
  borderRadius: "1000px",
  border: "1px solid var(--Color-Border-Active-On-Light, #1F1F1F)",
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 500,
  [theme.breakpoints.up("sm")]: {
    fontSize: "18px",
    lineHeight: "24px"
  }
}));

/**
 * Container for signatory items
 * @type {import('@emotion/styled').StyledComponent}
 */
export const SignatoryContainer = styled("div")(({ theme }) => ({
  borderRadius: "8px",
  boxShadow: "0 5px 21px 0 rgba(0, 0, 0, 0.03)",
  border: "solid 1px #e8e8e8",
  backgroundColor: "#ffffff",
  marginTop: "20px"
}));

/**
 * Wrapper for content
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ContentWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px"
}));

/**
 * Green avatar styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const GreenAvatar = styled("div")(({ theme }) => ({
  backgroundColor: "#166a2c",
  width: "40px",
  fontSize: "14px",
  fontWeight: 600
}));

/**
 * Name field styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const NameField = styled("div")(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: 1.33,
  color: "#373737",
  wordBreak: "break-all"
}));

/**
 * Signatory field styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const SignatoryField = styled("div")(({ theme }) => ({
  fontSize: "14px",
  lineHeight: "1.71",
  color: "#517085"
}));

/**
 * Shareholding field styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ShareholdingField = styled("div")(({ theme }) => ({
  opacity: 0.5,
  fontSize: "12px",
  lineHeight: 1.33,
  color: "#263d4c"
}));

/**
 * User info container styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const UserInfo = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "4px",
  flex: 1
}));

/**
 * Signatory rights styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const SignatoryRights = styled("div")(({ theme }) => ({
  fontSize: "14px",
  fontWeight: "normal",
  fontStyle: "normal",
  fontStretch: "normal",
  lineHeight: "1.29",
  letterSpacing: "normal",
  color: "#373737"
}));

/**
 * File upload placeholder styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const FileUploadPlaceholder = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "16px",
  border: "1px dashed #86868B",
  borderRadius: "10px",
  flexDirection: "column",
  justifyContent: "space-between",
  cursor: "pointer",
  gap: "24px",
  outline: "none",
  "&.disabledUpload": {
    opacity: 0.5,
    pointerEvents: "none"
  },
  [theme.breakpoints.up("sm")]: {
    padding: "24px",
    flexDirection: "row",
    minWidth: "unset",
    maxWidth: "unset"
  },
  "& .main": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    width: "100%",
    minWidth: 0,
    [theme.breakpoints.between("sm", "md")]: {
      width: "calc(100% - 105px)",
      flexDirection: "row",
      gap: "20px"
    },
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      gap: "20px"
    }
  },
  "& .row": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "unset"
    }
  },
  "& .fileIcon": {
    minWidth: "32px",
    [theme.breakpoints.up("sm")]: {
      minWidth: "40px"
    }
  }
}));

/**
 * Disabled element styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Disabled = styled("div")(({ theme }) => ({
  pointerEvents: "none",
  opacity: "0.6"
}));

/**
 * Alternate content box styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ContentBoxAlt = styled("div")(({ theme }) => ({
  alignItems: "center",
  flexGrow: "1",
  padding: "7px 18px"
}));

/**
 * Uploaded file name styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const UploadedFileName = styled("span")(({ theme }) => ({
  fontSize: "12px",
  fontWeight: "normal",
  fontStyle: "normal",
  fontStretch: "normal",
  lineHeight: "1",
  letterSpacing: "normal",
  color: "#373737",
  display: "block",
  wordBreak: "break-word"
}));

/**
 * File size message styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const FileSizeMessage = styled("div")(({ theme }) => ({
  color: "#888888",
  fontSize: "12px",
  fontWeight: "normal",
  fontStyle: "normal",
  fontStretch: "normal",
  lineHeight: ".6",
  letterSpacing: "normal",
  "& p": {
    margin: "3px 0 0 5px"
  },
  "@media (max-width: 620px)": {
    lineHeight: "1"
  }
}));

/**
 * Alternate controls box styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ControlsBoxAlt = styled("div")(({ theme }) => ({
  minWidth: "130px",
  height: "32px",
  borderRadius: "21px",
  border: "solid 1px #373737",
  fontSize: "14px",
  fontWeight: "normal",
  fontStyle: "normal",
  fontStretch: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#373737",
  cursor: "pointer",
  lineHeight: "2.2"
}));

/**
 * Uploaded content box styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const UploadedContentBox = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexGrow: "1",
  paddingLeft: "16px",
  paddingRight: "16px"
}));

/**
 * Upload file name styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const UploadFileName = styled("div")(({ theme }) => ({
  fontSize: "12px",
  fontWeight: "600",
  fontStyle: "normal",
  fontStretch: "normal",
  lineHeight: "1.17",
  letterSpacing: "normal",
  color: "#373737",
  display: "flex",
  alignItems: "center"
}));

/**
 * Signatory rights copy styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const SignatoryRightsAlt = styled("div")(({ theme }) => ({
  width: "39px",
  height: "14px",
  fontSize: "12px",
  fontWeight: "normal",
  fontStyle: "normal",
  fontStretch: "normal",
  lineHeight: "1.17",
  letterSpacing: "normal",
  color: "#888888",
  paddingLeft: "9px"
}));

/**
 * Signatory rights copy alternative styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const SignatoryRightsCopy = styled("div")(({ theme }) => ({
  width: "25px",
  height: "18px",
  fontSize: "12px",
  fontWeight: "600",
  fontStyle: "normal",
  fontStretch: "normal",
  lineHeight: "1.5",
  letterSpacing: "normal",
  textAlign: "right",
  color: "#373737",
  paddingLeft: "11px"
}));

/**
 * Cancel button styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Cancel = styled("div")(({ theme }) => ({
  minWidth: "24px",
  height: "24px",
  boxShadow: "0 5px 21px 0 rgba(0, 0, 0, 0.03)",
  cursor: "pointer"
}));

/**
 * Default input styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const DefaultInput = styled("input")(({ theme }) => ({
  display: "none"
}));

/**
 * Progress bar styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const MyProgressBar = styled("div")(({ theme }) => ({
  height: "4px",
  borderRadius: "3px",
  textAlign: "center",
  lineHeight: "32px",
  color: "black",
  backgroundColor: "#373737",
  width: "100%",
  transition: "width 0.2s ease"
}));

/**
 * Progress status styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ProgressStatus = styled("span")(({ theme }) => ({
  display: "inline-block",
  paddingLeft: "11px"
}));

/**
 * Name skeleton styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const NameSkeleton = styled("div")(({ theme }) => ({
  width: "210px",
  height: "40px",
  borderRadius: "8px",
  marginLeft: "25px"
}));

/**
 * Content skeleton styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ContentSkeleton = styled("div")(({ theme }) => ({
  width: "400px",
  height: "30px",
  margin: "20px 0 20px 15px",
  borderRadius: "8px"
}));

/**
 * Button skeleton styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ButtonSkeleton = styled("div")(({ theme }) => ({
  width: "140px",
  height: "35px",
  marginBottom: "0px",
  marginLeft: "230px",
  borderRadius: "28px"
}));

/**
 * Error explanation styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const ErrorExplanation = styled("p")(({ theme }) => ({
  fontSize: "12px",
  color: "#ea2925",
  margin: 0
}));

/**
 * Doc type explanation styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const DocTypeExplanation = styled("p")(({ theme }) => ({
  fontSize: "12px",
  color: "#263d4c",
  opacity: "0.5",
  margin: 0
}));

/**
 * Info titles styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const InfoTitles = styled("span")(({ theme }) => ({
  position: "relative",
  top: "-5px",
  textDecoration: "underline"
}));

/**
 * Upload info styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const UploadInfo = styled("div")(({ theme }) => ({
  display: "inline-flex"
}));

/**
 * Question icon styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const QuestionIcon = styled("img")(({ theme }) => ({
  width: "14px",
  height: "14px"
}));

/**
 * Multi grid styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const MultiGrid = styled("div")(({ theme }) => ({
  padding: 0
}));

/**
 * Multi add button styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const MultiAddBtn = styled("button")(({ theme }) => ({
  width: "132px",
  float: "right"
}));

/**
 * Disabled multi add button styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const DisabledMultiAddBtn = styled("button")(({ theme }) => ({
  color: "#ffffff",
  boxShadow: "none",
  cursor: "default",
  backgroundColor: "#c6c6cc",
  border: "none"
}));

/**
 * Download label styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const DownloadLabel = styled("div")(({ theme }) => ({
  margin: "15px 0"
}));

/**
 * Group container styling
 * @type {import('@emotion/styled').StyledComponent}
 */
export const GroupContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "16px"
}));

export const DocType = styled("div")(({ theme }) => ({
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 500,
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
}));

export const Divider = styled("div")(({ theme }) => ({
  width: "100%",
  height: "1px",
  marginTop: "24px",
  marginBottom: "24px",
  backgroundColor: "#E6E6E6"
}));

/**
 * Container for multi document upload component
 * @type {import('@mui/system').StyledComponent}
 */
export const MultiDocumentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: "16px"
}));

/**
 * Content area for document rows in multi document component
 * @type {import('@mui/system').StyledComponent}
 */
export const MultiDocumentContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: "1",
  gap: "16px",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    ...props =>
      props.multiDoc && {
        width: "calc(75% - 16px)"
      }
  }
}));

/**
 * Sidebar for add more button in multi document component
 * @type {import('@mui/system').StyledComponent}
 */
export const MultiDocumentSidebar = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "fit-content"
}));

/**
 * Row container for arranging content in multi document component
 * @type {import('@mui/system').StyledComponent}
 */
export const MultiDocumentRow = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  width: "100%"
}));

/**
 * Download steps container for multi document component
 * @type {import('@mui/system').StyledComponent}
 */
export const DownloadStepsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
  marginBottom: "16px"
}));
